import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { CustomerDetails } from '../types'

interface CustomerInfoProps {
  customerDetails: CustomerDetails
}

const CustomerInfo = ({ customerDetails }: CustomerInfoProps) => {
  const { t } = useTranslation()

  return (
    <Box className="max-w-lg">
      {customerDetails?.details &&
        Object.keys(customerDetails?.details)
          ?.filter(key => !!customerDetails?.details?.[key]?.trim())
          ?.map(key => (
            <Box key={`${customerDetails?.name}-${key}`} paddingB={12}>
              <DataListItem
                id={`${customerDetails?.name}-${key}`}
                title={t(`customers.${key}`)}
                body={customerDetails?.details?.[key]}
                layout="horizontal"
              />
            </Box>
          ))}
    </Box>
  )
}

export default CustomerInfo
